<div class="model-reg-beackdrop" *ngIf="regProgress || exeProgress">
  <div class="svg-loader"></div>
</div>
<div class="modal-header d-block"  *ngIf="!regProgress">
  <button type="button" class="close cancelBtn" aria-label="Close" mat-dialog-close>
    Close
  </button>
  <div class="row">
    <div class="col-sm-6">
      <h5 class="modal-title text-center">Input Parameters</h5>
    </div>
    <div class="col-sm-6">
      <h5 class="modal-title text-center">Output Parameters</h5>
    </div>
  </div>
</div>
<div class="modal-body" *ngIf="!regProgress">
  <div class="container" *ngIf="!errorMessage">
    <form (ngSubmit)="onSubmit()" #f="ngForm" [formGroup]="myFormGroup" >
      <div class="row">
        <div class="col-sm-6 paramContainer">
          <div *ngFor="let form_elem of form_template">
            <div [ngSwitch]="form_elem.type">
              <div *ngSwitchCase="'textBox'" class="form-group row">
                <label [for]="form_elem.label" class="col-sm-4 col-form-label">{{form_elem.label}}</label>
                <div class="col-sm-6">
                  <input type="text" class="form-control" [id]="form_elem.label"
                         formControlName="{{form_elem.inputModel}}"
                         required>
                </div>
              </div>
              <div *ngSwitchCase="'number'" class="form-group row">
                <label [for]="form_elem.label" class="col-sm-4 col-form-label">{{form_elem.label}}</label>
                <div class="col-sm-6">
                  <input type="number" class="form-control" [id]="form_elem.label"
                         formControlName="{{form_elem.inputModel}}"
                         required>
                </div>
              </div>
              <div *ngSwitchCase="'checkbox'" class="form-group row">
                <label [for]="form_elem.label" class="col-sm-4 col-form-label">{{form_elem.label}}</label>
                <div class="col-sm-6">
                  <input type="checkbox" class="form-control" [id]="form_elem.label"
                         formControlName="{{form_elem.inputModel}}">
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-6 paramContainer">
          <div class="outputContiner">
            <table class="table" aria-labelledby ="DataSource" *ngIf="responseOutput.length > 0">
              <thead>
                <tr>
                  <th scope="col">Parameter Name</th>
                  <th scope="col">Value</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of responseOutput">
                  <td>{{item.key}}</td>
                  <td>{{item.value}}</td>
                </tr>
              </tbody>
            </table>
            <div class="invalid-entry" *ngIf="!responseOutput && errorOutpuMsg">{{errorOutpuMsg}}</div>
          </div>
        </div>
      </div>
      <div class="row" *ngIf="!regProgress">
        <button type="button" class="uploadModelFile" (click)="onSubmit()" [disabled]="!f.valid"><mat-icon>play_circle_outline</mat-icon> <span>Model</span></button>
      </div>
    </form>
  </div>
  <div class="invalid-entry" *ngIf="errorMessage">{{errorMessage}}</div>
</div>
